<template>
  <Popup
    v-model:show="popVisible"
    teleport="body"
    height="100%"
    position="bottom"
  >
    <div class="language-and-currency">
      <div
        v-if="activeIndex === 0"
        class="header"
      >
        Settings
        <img
          @click="popVisible = false"
          src="@/assets/images/close-icon.svg"
          alt=""
        >
      </div>
      <div
        v-else
        class="header"
      >
        <Icon
          class="back-icon"
          @click="handleBack"
          name="icon-arrow-left-l"
        />
        <span>{{ activeIndex === 1 ? 'Language' : 'Currency' }}</span>
        <img
          @click="popVisible = false"
          src="@/assets/images/close-icon.svg"
          alt=""
        >
      </div>

      <div
        :style="{ transform: `translateX(${translateX})` }"
        class="body"
      >
        <div class="_item">
          <img
            src="@/assets/illus/h5-settings.svg"
            alt=""
          >
          <div class="title">
            Tell me more about yourself!
          </div>
          <div class="sub-title">
            We’ll provide you with comfortable browsing.
          </div>
          <div
            @click="handleTransform(1)"
            class="select-box"
          >
            <div class="label">
              Language
            </div>
            <div class="value">
              {{ currentLanguage }}
              <Icon
                class="icon"
                name="arrow-right-l-2"
              />
            </div>
          </div>
          <div
            @click="handleTransform(2)"
            class="select-box"
          >
            <div class="label">
              Currency
            </div>
            <div class="value">
              {{ currentCurrency }}
              <Icon
                class="icon"
                name="arrow-right-l-2"
              />
            </div>
          </div>
        </div>

        <!-- language -->
        <div
          v-show="activeIndex === 1"
          class="_item"
        >
          <div class="list">
            <div
              v-for="(item, index) in languageStore.list"
              :key="index"
              @click="handleLanguageChange(item)"
              class="list-item"
            >
              <div class="label">
                {{ item.sourceLan + ' / ' + String(item.language).toUpperCase() }}
              </div>
              <Icon
                v-if="item.language === languageStore.current"
                class="icon"
                name="radio-selected-f"
              />
            </div>
          </div>
        </div>

        <!-- currency -->
        <div
          v-show="activeIndex === 2"
          class="_item"
        >
          <div class="list">
            <div
              v-for="(item, index) in currencyStore.list"
              :key="index"
              @click="handleCurrencyChange(item)"
              class="list-item"
            >
              <div class="label">
                {{ item.targetCurrency.slice(0, 2) + ' ' + `(${item.targetUnit})` }}
              </div>
              <Icon
                v-if="item.targetCurrency === currencyStore.current.targetCurrency"
                class="icon"
                name="radio-selected-f"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { ref } from 'vue'
import { Popup } from '@/components/Popup'
import { Icon } from '@/components/Icon'
import { useLanguageStore } from '@/pinia/language'
import { useCurrencyStore } from '@/pinia/currency'

const popVisible = defineModel()

const languageStore = useLanguageStore()

const currencyStore = useCurrencyStore()

const translateX = ref(0)

const activeIndex = ref(0)

const currentLanguage = computed(() => {
  const target = languageStore.list.find(it => it.language === languageStore.current)
  return target.sourceLan
})

const currentCurrency = computed(() => {
  const current = currencyStore.current
  return current.targetCurrency.slice(0, 2) + ' ' + `(${current.targetUnit})`
})

const handleTransform = (index) => {
  activeIndex.value = index
  translateX.value = 'calc(-100% - 12px)'
}
const handleBack = () => {
  translateX.value = 0
  setTimeout(() => {
    activeIndex.value = 0
  }, 300)
}

const handleLanguageChange = (item) => {
  languageStore.update(item.language)
}

const handleCurrencyChange = (item) => {
  currencyStore.update(item)
}

</script>

<style lang='less' scoped>
.language-and-currency {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  height: 100%;
  .header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    height: 48px;
    background-color: white;
    border-radius: 8px;
    color: #232323;
    font-size: 14px;
    font-family: mon-700;
    .back-icon {
      font-size: 20px;
    }
  }
  .body {
    flex: 1;
    display: flex;
    gap: 12px;
    transition: transform .3s;
    height: calc(100% - 84px);

    ._item {
      flex-shrink: 0;
      width: 100%;
      height: 100%;
      background-color: white;
      border-radius: 8px;
      padding: 16px 12px;
      overflow-y: scroll;

      .title {
        color: #232323;
        font-size: 16px;
        font-family: mon-700;
        line-height: 24px
      }
      .sub-title {
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        line-height: 18px;
        margin-top: 3px;
        margin-bottom: 32px;
      }

      .select-box {
        margin-bottom: 24px;
        .label {
          color: #232323;
          font-size: 14px;
          font-family: mon-600;
        }
        .value {
          position: relative;
          display: flex;
          align-items: center;
          height: 48px;
          width: 100%;
          padding: 0 8px;
          border: 1px solid #EBF1F5;
          border-radius: 4px;
          margin-top: 12px;
          color: #232323;
          font-size: 12px;
          font-family: mon-500;

          .icon {
            position: absolute;
            top: 50%;
            right: 8px;
            transform: translateY(-50%);
            font-size: 14px;
          }
        }
      }

      .list {
        .list-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 56px;
          border-bottom: 1px solid #EBF1F5;
          .label {
            color: #232323;
            font-size: 14px;
            font-family: mon-600;
          }
          .icon {
            font-size: 20px;
          }
        }
      }
    }
  }
}
</style>
